<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
        disable-sort
        :loading="loading"
        :server-items-length="entitiesCount"
        disable-pagination
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Коллекции</v-toolbar-title>
                <v-spacer />
                <v-btn color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon> Добавить
                </v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment('DD.MM.YYYY') }}
        </template>
        <template v-slot:[`item.enabled`]="{ item }">
            <span :class="`true-false-label ${getBadge(item.enabled)}`">
                &nbsp;{{item.enabled ? 'Да' : 'Нет' }}&nbsp;
            </span>
        </template>
        <template v-slot:[`item.title`]="{ item }">
            <span class="title">{{ item.title }}</span>
        </template>
        <template v-slot:[`item.open`]="{ item }">
            <a :href="`/collections/${item.id}/detail`">
                <v-icon color="primary">mdi-eye</v-icon>
            </a>
        </template>
    </v-data-table>
</template>

<script>
    import store from '../../store';
    import { mapState } from 'vuex';

    export default {
        name: 'CollectionssList',
        components: {
        },
        data: () => ({
            loading: true,
            headers: [
                { text: 'Дата', value: 'created_at' },
                { text: 'Активность', value: 'enabled' },
                { text: 'Заголовок', value: 'title' },
                { text: '', align: 'right', value: 'open' },
            ]
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('collections', ['entities', 'entitiesCount']),
        },
        async mounted() {
            this.fetch();
        },
        methods: {
            async fetch() {
                this.loading = true;
                await store.dispatch('collections/fetch');
                this.loading = false;
            },
            async paginate({ page, itemsPerPage }) {
                this.page = page;
                this.itemsPerPage = itemsPerPage;
                await this.fetch();
            },
            async create() {
                await this.$router.push({ name: 'collections-create' });
            },
            async open(id) {
                await this.$router.push({ name: 'collections-detail', params: { id } });
            },
            getBadge (status) {
                return status ? 'success' : 'error';
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 16px !important;
        line-height: 18px;
        font-weight: 700;
    }
</style>